<template>
  <b-row class="base-row-padded">
    <b-col>
      <h2>Users</h2>
      <DataPagination
        :apiUrl="'users'"
        :startingPage="1"
        :perPage="20"
        :showSearch="true"
        :queryStructure="queryStructure"
        @items-updated="itemsUpdated"
        ref="paginationComponent"
      />
      <b-row>
        <b-col xs="10" class="mx-1 mb-2" align="start">
          <b-form inline>
            <b-form-select v-model="queryStructure.custom.role" @change="roleChanged">
              <option :value="null">Filter by role</option>
              <option v-for="(value, $index) in userRoles" :value="$index" :key="$index">{{value}}</option>
            </b-form-select>
          </b-form>
        </b-col>
        <b-col xs="2" class="mx-1 mb-2" align="end">
          <b-button variant="success" @click="createUser">New User</b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-table :fields="fields" :items="usersArray" :busy="usersArray === null"
          selectable @row-selected="showUser" :select-mode="'single'"
          :striped="true" :small="true" :hover="true" :responsive="true" :stacked="'sm'">
          <template slot="name" slot-scope="data">
            {{data.item.name}}
          </template>

          <template slot="email" slot-scope="data">
            {{data.item.email}}
          </template>

          <template slot="role" slot-scope="data">
            {{userRoles[data.item.role.id]}}
          </template>

          <template slot="id" slot-scope="data">
            <b-button class="m-1" variant="primary" size="sm" @click.prevent="showUser(data.item.id)">Edit</b-button>
            <b-button class="m-1" variant="danger" size="sm" @click.prevent="deleteUserProxy(data.item)">Delete</b-button>
          </template>
        </b-table>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import DataPagination from '@/components/DataPagination.vue';
import rolesMixin from '@/modules/rolesMixin';
import usersMixin from './usersMixin';

export default {
  components: { DataPagination },
  mixins: [rolesMixin, usersMixin],
  data() {
    return {
      usersArray: null,
      queryStructure: {
        pagePropName: 'page',
        perPagePropName: 'per_page',
        searchPropName: 'search',
        responseDataKey: 'users',
        custom: {
          role: null,
        },
      },
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'email', label: 'Email' },
        { key: 'role', label: 'Role' },
        { key: 'id', label: 'Options', tdClass: 'td-no-wrap' },
      ],
    };
  },
  methods: {
    itemsUpdated(data) {
      this.usersArray = data;
    },
    deleteUserProxy(user) {
      this.deleteUser(user).then(() => {
        this.$refs.paginationComponent.pageChanged();
      });
    },
    roleChanged() {
      this.$refs.paginationComponent.pageChanged(1);
    },
    showUser(target) {
      if (typeof target === 'number') {
        this.$router.push({ name: 'showUser', params: { id: target } });
      } else if (target && Array.isArray(target) && target[0] && target[0].id) {
        this.$router.push({ name: 'showUser', params: { id: target[0].id } });
      }
    },
    createUser() {
      this.$router.push({ name: 'showUser', params: { id: 'new' } });
    },
  },
};
</script>
